import { useEffect, useState } from 'react'
import styles from "./scss/usereports.module.scss"
import { DatePicker, Dropdown, MenuProps, Modal, Select, Space, Table } from 'antd'
import calenderic from "../../../../src/styles/images/calendericoagentn.svg"
import { ReportServices } from '../../../base/service/apiServices';
import { SecondsToTime } from '../../main_layout/navigation/settings/basic_configuration/reports/voiceChannel/commonindex';
import moment, { Moment } from 'moment';
import CreateScheduledReports from "../../reports/scheduledreports/createscheduledreports";
import { progressNotify, successNotify } from '../../../base/reportsAndAnalyticsUtils';
import FileSaver from 'file-saver';
import IfEmptyContent from '../../../shared/widges/ifEmptyContent';
import Loaders from '../../../components/loader/loader'
import nodata1 from "../../../styles/images/nodataimg.svg";
import { WtButton } from '../../../shared/widges/Button/button';
import { useNavigate } from "react-router";

function Usereports() {
    const navigate = useNavigate();
    // This page is dedicated to the User Report; the Agent/Summary options in the
    // dropdown navigate to the campaign reports page instead of switching in place.
    const activeReport = 'user';
    const { RangePicker }: any = DatePicker;
    const [tableColumns, setTableColumns] = useState<any>([]);
    const [tableData, setTableData] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    const [filters, setFilters] = useState({
        dateRanges: 'today', // or 'custom', 'yesterday', etc.
        customRange: {
            from: null,
            to: null,
        },
        campaign: undefined as any,
        agent: undefined as any,
        callStatus: undefined as any,
        disposition: undefined as any,
    });
    // Options for the User Report filter dropdowns (populated from the report API response)
    const [userFilterOptions, setUserFilterOptions] = useState<any>({
        campaignList: [],
        agentList: [],
        callStatusList: [],
        dispositionList: [],
    });
    // Server-side pagination for the User Report
    const [userPage, setUserPage] = useState({ current: 1, pageSize: 10 });
    const [userTotal, setUserTotal] = useState(0);

    // Update a User Report filter and reset back to the first page
    const applyUserFilter = (key: string, value: any) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
        setUserPage((prev) => ({ ...prev, current: 1 }));
    };
    const [, setEditColumnVisible] = useState<any>(false);
    const [showEditColumn] = useState("")
    const [editColumnList, setEditColumnList] = useState<any>({
        columnShow: false, editColumnArray: [], reportId: 0, reportType: " "
    });
    const [open, setOpen] = useState<any>(false)
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const [dateRangePickerOpen, setDateRangePickerOpen] = useState(false);

    const [tempDates, setTempDates] = useState<[moment.Moment | null, moment.Moment | null]>([null, null]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [advancedFilter, setAdvancedFilter] = useState(false);

    const userColumns = [
        {
            title: 'Campaign name',
            dataIndex: 'campaignname',
            key: 'campaignname',
        },
        {
            title: 'Agent',
            dataIndex: 'agent',
            key: 'agent',
        },
        {
            title: 'Number',
            dataIndex: 'Number',
            key: 'Number',
        },
        {
            title: 'Customer Name',
            dataIndex: 'Customer Name',
            key: 'customerName',
        },
        {
            title: 'Date',
            dataIndex: 'Date',
            key: 'date',
        },
        {
            title: 'Time',
            dataIndex: 'Time',
            key: 'time',
        },
        {
            title: 'Duration',
            dataIndex: 'duration',
            key: 'duration',
        },
        {
            title: 'Call Status',
            dataIndex: 'Call Status',
            key: 'callStatus',
        },
        {
            title: 'Disposition Status',
            dataIndex: 'Disposition Status',
            key: 'dispositionStatus',
            render: (_: any, record: any) => (
                record['Disposition Status'] && record['Disposition Status'] !== '-' ? (
                    <div
                        className={`${styles.badge} ${record.colorCode ? '' : styles.followup}`}
                        style={record.colorCode ? { color: record.colorCode, backgroundColor: `${record.colorCode}1A`, borderColor: record.colorCode } : undefined}
                    >
                        {record['Disposition Status']}
                    </div>
                ) : <span>-</span>
            ),
        },
        {
            title: 'Note',
            dataIndex: 'Note',
            key: 'note',
            render: (_: any, record: any) => (
                record?.Note?.length ? (
                    <div className={styles.viewnote}
                        onClick={() => { setnotesMsg(record.Note); setIsModalOpen(true); }}
                    >
                         {record?.Note?.length > 1 ? `${record?.Note?.length} Notes added` : 'Note added'} 
                    </div>
                ) : <span>-</span>
            ),
        }
    ];
    
    const parseNotes = (notes: any): any[] | null => {
        if (!notes) return null;
        if (Array.isArray(notes)) return notes.length ? notes : null;
        try {
            const parsed = JSON.parse(notes);
            return Array.isArray(parsed) && parsed.length ? parsed : null;
        } catch {
            return null;
        }
    };

    const getDateRange = (range?: string) => {
        const selectedRange = range ?? filters.dateRanges;
        const today = moment();

        switch (selectedRange) {
            case "today":
                return {
                    startDate: today.format("YYYY-MM-DD"),
                    endDate: today.format("YYYY-MM-DD"),
                };
            case "yesterday":
                const yesterday = today.clone().subtract(1, "day");
                return {
                    startDate: yesterday.format("YYYY-MM-DD"),
                    endDate: yesterday.format("YYYY-MM-DD"),
                };
            case "last 7 days":
                return {
                    startDate: today.clone().subtract(6, "days").format("YYYY-MM-DD"),
                    endDate: today.format("YYYY-MM-DD"),
                };
            case "custom":
                if (filters.customRange.from && filters.customRange.to) {
                    return {
                        startDate: moment(filters.customRange.from).format("YYYY-MM-DD"),
                        endDate: moment(filters.customRange.to).format("YYYY-MM-DD"),
                    };
                }
                return;
            default:
                return;
        }
    };

    const showDrawer = () => {
        setOpen(!open);
    }
    useEffect(() => {
        if (filters.dateRanges) {
            const body = getDateRange(filters.dateRanges);
            getUserData(body);
        }
    }, [filters.dateRanges, filters.customRange, filters.campaign, filters.agent, filters.callStatus, filters.disposition, userPage.current, userPage.pageSize]);

    const getUserData = (body: any) => {
        // body already carries startDate / endDate from getDateRange(). domainId is added
        // by the backend from auth, so it is not sent here.
        // Multi-select filters are sent as comma-separated ids, e.g. "12546,12548".
        const joinIds = (v: any) => (Array.isArray(v) && v.length ? v.join(',') : null);
        const fullBody = {
            ...body,
            campaignName: joinIds(filters.campaign),       // campaign name(s)
            callStatus: joinIds(filters.callStatus),       // call status value(s)
            agentName: joinIds(filters.agent),             // AgentId(s)
            dispositionName: joinIds(filters.disposition), // dispositionId(s)
            offset: (userPage.current - 1) * userPage.pageSize,
            limit: userPage.pageSize,
        };
        setLoading(true);
        ReportServices.post(fullBody, "/get_user_compaign_report")
            .then((response: any) => {
                if (response.data.statusCode === 200) {
                    const rawData = response?.data?.getoutboundReportRes || [];

                    const mappedData = rawData.map((item: any, index: number) => ({
                        key: index,
                        campaignname: item.campaignName ?? '-',
                        agent: item.Agent || '-',
                        Number: item.number ?? '-',
                        'Customer Name': item.customerName?.trim() ? item.customerName : '-',
                        Date: item.date ? new Date(item.date).toLocaleDateString() : '-',
                        Time: item.time ?? '-',
                        duration: item.duration != null ? SecondsToTime(item.duration) : '-',
                        'Call Status': item.callstatus ?? '-',
                        'Disposition Status': item.dispositionStatus ?? '-',
                        colorCode: item.colorCode ?? null,
                        Note: parseNotes(item.Notes),
                    }));

                    setTableData(mappedData);
                    setTableColumns(userColumns);
                    // No total count in the response, so fall back to the row count.
                    setUserTotal(response.data.totalCount ?? response.data.total ?? response.data.count ?? rawData.length);

                    // The response has no dedicated option lists, so derive unique filter values from the rows.
                    // Keep an existing list when its filter is active so options don't disappear after filtering.
                    const hasVal = (v: any) => v !== null && v !== undefined && String(v).trim() !== '';
                    const uniq = (arr: any[]) => Array.from(new Set(arr.filter(hasVal)));
                    // Dedupe to { id, name } pairs keyed by id (for campaign/agent where we filter by id).
                    const uniqById = (arr: any[], idKey: string, nameKey: string) => {
                        const map = new Map();
                        arr.forEach((r: any) => {
                            if (hasVal(r[idKey]) && !map.has(r[idKey])) map.set(r[idKey], { id: r[idKey], name: r[nameKey] });
                        });
                        return Array.from(map.values());
                    };
                    setUserFilterOptions((prev: any) => ({
                        // Campaign filters by name; agent & disposition filter by id.
                        campaignList: (filters.campaign?.length ? prev.campaignList : uniq(rawData.map((r: any) => r.campaignName))),
                        agentList: (filters.agent?.length ? prev.agentList : uniqById(rawData, 'AgentId', 'Agent')),
                        callStatusList: (filters.callStatus?.length ? prev.callStatusList : uniq(rawData.map((r: any) => r.callstatus))),
                        dispositionList: (filters.disposition?.length ? prev.dispositionList : uniqById(rawData, 'dispositionId', 'dispositionStatus')),
                    }));
                }
            })
            .catch((error: any) => console.log(error))
            .finally(() => setLoading(false));
    };
    const [notesMsg, setnotesMsg] = useState<any>("");

    const items: MenuProps['items'] = [
        {
            key: 'agent',
            label: (
                <div className="agentsumm" style={{ width: '100%' }} onClick={() => navigate('/outboundcampaignreports', { state: { activeReport: 'agent' } })}>
                    Agent Outbound Campaign Report Metrics
                </div>
            ),
        },
        {
            key: 'summary',
            label: (
                <div className="agentsumm" style={{ width: '100%' }} onClick={() => navigate('/outboundcampaignreports', { state: { activeReport: 'summary' } })}>
                    Campaign Summary Report Metrics
                </div>
            ),
        },
    ].filter(Boolean) as MenuProps['items'];
    const disabledDate = (current: Moment | null) => {
        return current && current > moment().endOf('day');
    };
    const handleExport = () => {
        try {
            if (!tableData?.length) {
                return;
            }
            progressNotify();
            // Build the CSV straight from the displayed rows/columns so already-formatted
            // values (duration, time, etc.) are exported verbatim instead of being
            // re-processed (which turned the formatted duration string into NaN:NaN:NaN).
            const escapeCsv = (val: any) => {
                const s = val == null ? '' : String(val);
                return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
            };
            const headerTitles = tableColumns.map((col: any) => col.title);
            const rows = tableData.map((row: any) =>
                tableColumns.map((col: any) => {
                    const value = row[col.dataIndex];
                    // Notes column holds a parsed array — flatten to readable text (strip HTML).
                    if (Array.isArray(value)) {
                        return value
                            .map((n: any) => (n?.message ?? '').replace(/<[^>]*>/g, '').trim())
                            .filter(Boolean)
                            .join(' | ');
                    }
                    return value ?? '-';
                })
            );
            const csv = [headerTitles, ...rows]
                .map((line: any[]) => line.map(escapeCsv).join(','))
                .join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const fileName = activeReport === 'user'
                ? 'User_Report'
                : activeReport === 'summary'
                    ? 'Campaign_Summary_Report'
                    : 'Agent_OutboundCampaign_Report';
            FileSaver.saveAs(blob, `${fileName}_${moment().format('DD/MM/YYYY')}.csv`);
            successNotify('Download completed');
        } catch (error) {
            console.log("handleExport", error)
        }
    }

    const actionsDropDown = (e: any) => {

        if (e === "Edit Column") {
            showModal()
            return setEditColumnList({ ...editColumnList, columnShow: true })

        }
        else {
            return handleExport();
        }
    };

    const showModal = () => {
        setEditColumnVisible(true);
    };
    const handleClearFilters = () => {
        setFilters({
            dateRanges: 'today', // Reset to today
            customRange: { from: null, to: null }, // Clear custom
            campaign: undefined,
            agent: undefined,
            callStatus: undefined,
            disposition: undefined,
        });
        setDateRangePickerOpen(false)
        setIsPickerOpen(false)
    };

    useEffect(() => {
        const handleScroll = () => {
            if (isPickerOpen) {
                setIsPickerOpen(false);
            }
        };
        window.addEventListener('scroll', handleScroll, true);
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [isPickerOpen]);

    return (
        <div className="noFluid">
            <div className="titleArea">

                <h3>  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none" onClick={() => navigate('/reportsmain')}>
                    <path d="M7.07327 16.4839C6.84187 16.4839 6.61037 16.395 6.43457 16.2183L0.916969 10.6665C-0.268531 9.47315 -0.269531 7.53085 0.915969 6.33745L6.43057 0.785646C6.78017 0.431146 7.35147 0.432146 7.70307 0.780746C8.05657 1.13135 8.05857 1.70065 7.70797 2.05325L2.19337 7.60505C1.70217 8.09915 1.70317 8.90295 2.19437 9.39705L7.71197 14.9488C8.06157 15.3013 8.06057 15.8717 7.70807 16.2222C7.53227 16.396 7.30277 16.4839 7.07327 16.4839Z" fill="#757676" />
                </svg>Campaign Reports</h3>
                <p className="witharrow">
                    Get a quick snapshot of your outbound campaign’s performance—track call attempts, connection rates, and key outcomes in real time.
                </p>

            </div>
            <div className="boxWhite ">
                <div>
                    <div className='reportsdropdwonnew'>
                        <Dropdown menu={{ items }} trigger={['click']} className='agentsumm'>
                            <a className="ant-dropdown-link">
                                <h5 style={{ color: '#575CFF' }}>
                                    User Report
                                </h5><span>  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none" style={{ transform: "rotate(180deg)" }}>
                                    <path d="M10.9154 5.90416C10.723 5.90416 10.5306 5.83096 10.3842 5.68346L6.53069 1.81826C6.38909 1.67666 6.20059 1.59856 5.99989 1.59756C5.79919 1.59756 5.61029 1.67666 5.46819 1.81826L1.61569 5.68346C1.32369 5.97736 0.848086 5.97736 0.555186 5.68546C0.261686 5.39246 0.260787 4.91786 0.553187 4.62496L4.40619 0.759757C4.83199 0.332957 5.39789 0.0976562 5.99999 0.0976562C6.60209 0.0986563 7.16799 0.333057 7.59329 0.759757L11.4468 4.62496C11.7393 4.91796 11.7383 5.39256 11.4448 5.68546C11.2988 5.83096 11.1068 5.90416 10.9154 5.90416Z" fill="#575CFF" />
                                </svg></span>
                            </a>
                        </Dropdown>

                    </div>
                    <div className="topbarmain">
                        <div className={`advanceSec showadvance topbarrowleft ${styles.topfiltercontainer} ${styles.filterinpute}`}>
                            <div className={styles.firstfilter}>
                                <div className={`inpelems inputlistfiltertype ${styles.inputle}`}>
                                    <Select
                                        className="antSelect greyBg "
                                        popupClassName="antSelectPopover selewidt"
                                        showSearch={false}
                                        placeholder="Select Date Range"
                                        value={filters.dateRanges}
                                        onChange={(value) => {
                                            if (value === "custom") {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    dateRanges: 'custom', // ✅ immediately reflect 'custom' as selected
                                                }));
                                                setDateRangePickerOpen(true);
                                            } else {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    dateRanges: value,
                                                    customRange: { from: null, to: null }, // optional: clear custom range
                                                }));
                                                setDateRangePickerOpen(false);
                                            }
                                            if (value === 'custom') {
                                                setDateRangePickerOpen(true);
                                            } else {
                                                setDateRangePickerOpen(false);
                                            }

                                        }}
                                        suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                            <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                        </svg>}
                                    >
                                        <Option value="today">Today</Option>
                                        <Option value="yesterday">Yesterday</Option>
                                        <Option value="last 7 days">Last 7 days</Option>
                                        <Option value="custom">Custom Date</Option>
                                    </Select>
                                </div>
                                {dateRangePickerOpen && (
                                    <div className="rangePicker activityrangepicker inpelems acc inputacctu">
                                        <RangePicker
                                            allowClear={false}
                                            style={{ width: '220px' }}
                                            disabledDate={disabledDate}
                                            onChange={(dates: any) => {
                                                if (Array.isArray(dates) && dates[0] && dates[1]) {
                                                    setTempDates([moment(dates[0]), moment(dates[1])]);
                                                } else {
                                                    setTempDates([null, null]);
                                                }
                                            }}
                                            value={tempDates[0] && tempDates[1] ? tempDates : null}
                                            suffixIcon={<img src={calenderic} alt="calendar icon" />}
                                            open={isPickerOpen}
                                            format="DD/MM/YYYY"
                                            onOpenChange={(open: any) => {
                                                if (open) {
                                                    setIsPickerOpen(true);
                                                }
                                            }}
                                            onBlur={() => setIsPickerOpen(false)}
                                            inputReadOnly
                                            renderExtraFooter={() => (
                                                <>
                                                    <div className="manualinputblock">
                                                        <div className="fromdateblock">
                                                            {tempDates[0] ? tempDates[0].format('DD/MM/YYYY') : 'DD/MM/YYYY'}
                                                        </div>
                                                        <div className="todateblock">
                                                            {tempDates[1] ? tempDates[1].format('DD/MM/YYYY') : 'DD/MM/YYYY'}
                                                        </div>
                                                    </div>
                                                    <div className="rangepickerfooter">
                                                        <div
                                                            className={`lefts ${tempDates[0] && tempDates[1] ? 'activered' : ''}`}
                                                            onClick={() => {
                                                                setTempDates([null, null]);
                                                                setFilters(prev => ({
                                                                    ...prev,
                                                                    customRange: { from: null, to: null },
                                                                }));
                                                            }}
                                                        >
                                                            Reset
                                                        </div>
                                                        <div className="rights">
                                                            <button
                                                                className="primarybtn"
                                                                onClick={() => {
                                                                    if (tempDates[0] && tempDates[1]) {
                                                                        const fromTimestamp = moment(tempDates[0]).valueOf();
                                                                        const toTimestamp = moment(tempDates[1]).valueOf();

                                                                        setFilters((prev: any) => ({
                                                                            ...prev,
                                                                            dateRanges: 'custom',
                                                                            customRange: {
                                                                                from: fromTimestamp,
                                                                                to: toTimestamp,
                                                                            },
                                                                        }));
                                                                        setIsPickerOpen(false);
                                                                        // setDateRangePickerOpen(false); // optionally close custom picker
                                                                    }
                                                                }}
                                                            >
                                                                Apply
                                                            </button>

                                                            <button
                                                                className="cancelbtn"
                                                                onClick={() => {
                                                                    setTempDates([
                                                                        filters.customRange?.from ? moment(filters.customRange.from) : null,
                                                                        filters.customRange?.to ? moment(filters.customRange.to) : null,
                                                                    ]);
                                                                    setIsPickerOpen(false);
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        />
                                    </div>
                                )}
                                {/* <div className="inpelems inputantsel inputlistfiltertype inpelemsminwidth">
                                    <Select
                                        className={` antSelect`}
                                        popupClassName="antSelectPopover activitySelect tickrightremove"
                                        placeholder="Time Zone"
                                        showArrow={true}
                                        suffixIcon={<span className="icon__SelectDownArrow16">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                <path d="M6.2572 5.90231C5.6547 5.90231 5.0892 5.66791 4.6639 5.24121L0.810397 1.37691C0.517897 1.08391 0.518897 0.609307 0.811897 0.316407C1.1058 0.024407 1.5809 0.0244068 1.8729 0.318407L5.7259 4.18271C6.0096 4.46591 6.5052 4.46591 6.7879 4.18271L10.6414 0.318407C10.9334 0.0245068 11.4085 0.024507 11.7024 0.316407C11.9954 0.609407 11.9963 1.08401 11.7039 1.37691L7.8504 5.24121C7.4251 5.66801 6.8593 5.90231 6.2572 5.90231Z" fill="#757676" />
                                            </svg>
                                        </span>}
                                        getPopupContainer={(trigger) => trigger.parentNode}
                                        mode="multiple"
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                        maxTagCount={1}
                                    >
                                        <option className="optionGrpTop assigncheckdrop" value="__clear1__" >Clear Selection</option>

                                    </Select>
                                </div> */}
                                {activeReport === 'user' && (
                                <div className="inpelems inputantsel inputlistfiltertype inpelemsminwidth">
                                    <Select
                                        className={` antSelect`}
                                        popupClassName="antSelectPopover activitySelect tickrightremove"
                                        placeholder="Campaign name"
                                        showArrow={true}
                                        suffixIcon={<span className="icon__SelectDownArrow16">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                <path d="M6.2572 5.90231C5.6547 5.90231 5.0892 5.66791 4.6639 5.24121L0.810397 1.37691C0.517897 1.08391 0.518897 0.609307 0.811897 0.316407C1.1058 0.024407 1.5809 0.0244068 1.8729 0.318407L5.7259 4.18271C6.0096 4.46591 6.5052 4.46591 6.7879 4.18271L10.6414 0.318407C10.9334 0.0245068 11.4085 0.024507 11.7024 0.316407C11.9954 0.609407 11.9963 1.08401 11.7039 1.37691L7.8504 5.24121C7.4251 5.66801 6.8593 5.90231 6.2572 5.90231Z" fill="#757676" />
                                            </svg>
                                        </span>}
                                        showSearch={false}
                                        allowClear
                                        mode="multiple"
                                        maxTagCount={1}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                        value={filters.campaign}
                                        onChange={(value: any) => applyUserFilter('campaign', value)}
                                    >
                                        {userFilterOptions?.campaignList?.map((data: any, index: any) => (
                                            <Option key={index} value={data}>
                                                {data}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                )}
                                {activeReport === 'user' && (
                                <div className={styles.advanceSearch} style={{ cursor: 'pointer' }} onClick={() => setAdvancedFilter(prev => !prev)}>
                                    Advanced Filter <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none" style={{ transform: advancedFilter ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                        <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000" />
                                    </svg>
                                </div>
                                )}
                            </div>
                            <div className={styles.firstfilter}>
                                {activeReport === 'user' && advancedFilter && (
                                <div className="inpelems inputantsel inpelemsminwidth inputlistfiltertype">
                                    <Select
                                        className={` antSelect`}
                                        popupClassName="antSelectPopover activitySelect tickrightremove"
                                        placeholder="Call Status"
                                        showArrow={true}
                                        suffixIcon={<span className="icon__SelectDownArrow16">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                <path d="M6.2572 5.90231C5.6547 5.90231 5.0892 5.66791 4.6639 5.24121L0.810397 1.37691C0.517897 1.08391 0.518897 0.609307 0.811897 0.316407C1.1058 0.024407 1.5809 0.0244068 1.8729 0.318407L5.7259 4.18271C6.0096 4.46591 6.5052 4.46591 6.7879 4.18271L10.6414 0.318407C10.9334 0.0245068 11.4085 0.024507 11.7024 0.316407C11.9954 0.609407 11.9963 1.08401 11.7039 1.37691L7.8504 5.24121C7.4251 5.66801 6.8593 5.90231 6.2572 5.90231Z" fill="#757676" />
                                            </svg>
                                        </span>}
                                        getPopupContainer={(trigger) => trigger.parentNode}
                                        showSearch={false}
                                        allowClear
                                        mode="multiple"
                                        maxTagCount={1}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                        value={filters.callStatus}
                                        onChange={(value: any) => applyUserFilter('callStatus', value)}
                                    >
                                        {userFilterOptions?.callStatusList?.map((data: any, index: any) => (
                                            <Option key={index} value={data}>
                                                {data}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                )}
                                {activeReport === 'user' && advancedFilter && (
                                <div className="inpelems inputantsel inpelemsminwidth inputlistfiltertype">
                                    <Select
                                        className={` antSelect`}
                                        popupClassName="antSelectPopover activitySelect tickrightremove"
                                        placeholder="Agent Name"
                                        showArrow={true}
                                        suffixIcon={<span className="icon__SelectDownArrow16">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                <path d="M6.2572 5.90231C5.6547 5.90231 5.0892 5.66791 4.6639 5.24121L0.810397 1.37691C0.517897 1.08391 0.518897 0.609307 0.811897 0.316407C1.1058 0.024407 1.5809 0.0244068 1.8729 0.318407L5.7259 4.18271C6.0096 4.46591 6.5052 4.46591 6.7879 4.18271L10.6414 0.318407C10.9334 0.0245068 11.4085 0.024507 11.7024 0.316407C11.9954 0.609407 11.9963 1.08401 11.7039 1.37691L7.8504 5.24121C7.4251 5.66801 6.8593 5.90231 6.2572 5.90231Z" fill="#757676" />
                                            </svg>
                                        </span>}
                                        getPopupContainer={(trigger) => trigger.parentNode}
                                        showSearch={false}
                                        allowClear
                                        mode="multiple"
                                        maxTagCount={1}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                        value={filters.agent}
                                        onChange={(value: any) => applyUserFilter('agent', value)}
                                    >
                                        {userFilterOptions?.agentList?.map((data: any, index: any) => (
                                            <Option key={index} value={data.id}>
                                                {data.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                )}
                                {activeReport === 'user' && advancedFilter && (
                                <div className="inpelems inputantsel inpelemsminwidth inputlistfiltertype">
                                    <Select
                                        className={` antSelect`}
                                        popupClassName="antSelectPopover activitySelect tickrightremove"
                                        placeholder="Disposition status"
                                        showArrow={true}
                                        suffixIcon={<span className="icon__SelectDownArrow16">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                <path d="M6.2572 5.90231C5.6547 5.90231 5.0892 5.66791 4.6639 5.24121L0.810397 1.37691C0.517897 1.08391 0.518897 0.609307 0.811897 0.316407C1.1058 0.024407 1.5809 0.0244068 1.8729 0.318407L5.7259 4.18271C6.0096 4.46591 6.5052 4.46591 6.7879 4.18271L10.6414 0.318407C10.9334 0.0245068 11.4085 0.024507 11.7024 0.316407C11.9954 0.609407 11.9963 1.08401 11.7039 1.37691L7.8504 5.24121C7.4251 5.66801 6.8593 5.90231 6.2572 5.90231Z" fill="#757676" />
                                            </svg>
                                        </span>}
                                        showSearch={false}
                                        allowClear
                                        mode="multiple"
                                        maxTagCount={1}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                        value={filters.disposition}
                                        onChange={(value: any) => applyUserFilter('disposition', value)}
                                    >
                                        {userFilterOptions?.dispositionList?.map((data: any, index: any) => (
                                            <Option key={index} value={data.id}>
                                                {data.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                )}
                                {activeReport === 'user' && advancedFilter && (
                                <p onClick={handleClearFilters} style={{ cursor: 'pointer', color: 'blue' }}>
                                    Clear All
                                </p>
                                )}

                            </div>

                        </div>
                        <div className='topbarrowright'>
                            <div className="actionselectbtn antSelectcot">
                                <Select
                                    className="antSelect"
                                    popupClassName="antSelectPopover"
                                    onChange={(e: any) => {
                                        actionsDropDown(e);
                                    }}
                                    placeholder="Actions"
                                    suffixIcon={<span className="icon__SelectDownArrow16"></span>}
                                    value={showEditColumn === "Import" || showEditColumn === "Edit Column" ? "Actions" : null}
                                    options={[
                                        {
                                            value: "Export",
                                            label: "Export",
                                        },
                                    ]}
                                />
                            </div>
                            <button className="buttonGreenCreate" onClick={showDrawer} >
                                Schedule Report
                            </button>
                            {
                                open && <CreateScheduledReports drawerOpen={open} drawerOpenClose={showDrawer} />
                            }

                        </div>
                    </div>
                    {/* Desktop Table */}
                    <div style={{ margin: "0 16px 0 16px" }}>
                        <div className="desktoptablecontainer ifempty">
                            {loading ? <Loaders /> : <Table
                                columns={tableColumns}
                                dataSource={tableData}
                                bordered
                                className="borderedAntTable overflowscrollertableclass"
                                showSorterTooltip={false}
                                tableLayout="fixed"
                                pagination={activeReport === 'user' ? {
                                    current: userPage.current,
                                    pageSize: userPage.pageSize,
                                    total: userTotal,
                                    showSizeChanger: true,
                                    onChange: (page: number, pageSize: number) => setUserPage({ current: page, pageSize }),
                                } : { showSizeChanger: true }}
                                locale={{
                                    emptyText: (
                                        <span className='datafoundcent'>
                                            <IfEmptyContent image={nodata1} title={""} description={"No Data"} />
                                        </span>
                                    ),
                                }}
                            />}


                        </div>
                    </div>
                </div>
            </div>
            <Modal
                title={<span>Notes</span>}
                open={isModalOpen}
                className="customModal sizeMD skilldisable"
                centered
                closeIcon={<span className="icon__Close16" onClick={() => setIsModalOpen(false)}></span>}
                footer={[
                    <Space>
                        <WtButton
                            name="Close"
                            className="buttonCancel"
                            onClick={() => setIsModalOpen(false)}
                        />
                    </Space>,
                ]}
            >
                <div className={styles.tabnoteskey}>
                    {notesMsg && notesMsg.length > 0 ? (
                        notesMsg.map((note: any, index: number) => (
                            <div key={index} className={styles.lightsinternet}>
                                <div style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: note.message }} />
                                <p className={styles.graytext}>
                                    {note.userName || "Agent"} -{" "}
                                    <span>{note.timestamp ? moment(note.timestamp).format("MMM D, YYYY • h:mm A") : ""}</span>
                                </p>
                            </div>
                        ))
                    ) : (
                        <p>No notes available.</p>
                    )}
                </div>
            </Modal>
        </div>

    )
}

export default Usereports